/*
 * @Author: limin
 * @Date: 2019-08-26 18:02:41
 * @Last Modified by: chenwq
 * @Last Modified time: 2021-06-30 14:30:41
 */

// import axios from "@/plugin/axios"
import axios from "@/plugin/axios/index_code"
import sign from "./sign"
import RequestMethods from "./request.methods"
import util from "@/libs/util.js"
import { baseConfig } from "@/main"
import axiosPackage from "axios"
const request = (
  params = {},
  method = RequestMethods.GET,
  noSignAttr = [],
  options
) => {
  // 兼容线上dj和scrm appkey和secret不一样的情况
  let apiName = ""
  if (params.method.includes("dj")) {
    apiName = "dj"
  } else {
    apiName = params.method.split(".api")[0]
    if (apiName == "scrm") {
      // 使用split方法分割字符串
      const parts = params.method.split(".")
      // 提取服务字段  索引3对应服务字段
      apiName = parts[2]
    }
  }
  // console.log("params.method", params.method)
  // console.log("apiName", apiName)
  // 为空报错
  if (!apiName) {
    throw new Error("apiName is null")
  }
  const mappingName = {
    "dj.smartcarlife": "axios",
    dj: "axios",
    shopmall: "axios2",
    merchants: "axios3",
    reportExport: "axios4",
    "glsx.accounts.biz.common.pictureUpload": "common",
    clue: "axios5",
    sso: "axios6",
    ssoCenter: "axios7"
  }

  const baseApiName = mappingName[apiName]
  // console.log(baseApiName, baseConfig, "baseApiName")
  // params.appKey = baseConfig[baseApiName].appkey
  if (baseApiName == "common") {
    params.app_key = baseConfig[baseApiName].appkey
  } else {
    params.appKey = baseConfig[baseApiName].appkey || ""
  }
  // console.log("params.appKey", params.appKey)
  params.timestamp = new Date().getTime()
  params.v = "1.0.0"
  params.format = "json"
  params.locale = "zh_CN"
  if (params.method !== "dj.api.user.login") {
    params.sessionId = util.cookies.get("token")
  }
  /**
   * mock - url = params.method
   * 调后端接口 - url = ''
   */
  const url = baseConfig[baseApiName].baseURL
  // const url = "/api"
  /**
   * 调后端接口，请使用以下代码。
   */
  const signWay = {
    "dj.smartcarlife": "sha1",
    dj: "sha1",
    scrm: "sha1",
    glsx: "md5",
    "glsx.accounts.biz.common.pictureUpload": "md5",
    clue: "sha1"
  }
  // console.log(signWay[apiName], "baseApiName")
  const secret = baseConfig[baseApiName].secret || ""
  const CancelToken = axiosPackage.CancelToken
  var reqData =
    method === RequestMethods.POST
      ? {
          baseURL: "/",
          data: sign(params, noSignAttr, secret, signWay[apiName])
        }
      : { params: sign(params, noSignAttr, secret, signWay[apiName]) }
  reqData = reqData = Object.assign(reqData, options, {})
  // 请求进度
  if (params?.onProcess) {
    reqData.onUploadProgress = params.onProcess
  }
  // 取消请求
  if (params?.cancelFun) {
    reqData.cancelToken = new CancelToken(function excutor(c) {
      params.cancelFun.cancel = c
    })
  }
  // console.log(method === RequestMethods.POST)
  // console.log(url)
  // console.log(options)
  // console.log(reqData)
  return axios({
    url,
    method,
    ...reqData
  })

  /**
   * mock，请使用以下代码。
   */
  // return axios({
  //   url,
  //   method,
  //   params: sign(params, noSignAttr)
  // })
}
export default request
